import { render, staticRenderFns } from "./suporte-procedimentos-apenas-hospital-dia.vue?vue&type=template&id=057470da"
import script from "./suporte-procedimentos-apenas-hospital-dia.vue?vue&type=script&lang=ts"
export * from "./suporte-procedimentos-apenas-hospital-dia.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports